<template>
  <div
    class="bg-white grid grid-cols-1 items-center justify-between gap-4 py-4 md:grid-cols-2 lg:flex"
  >
    <div class="grid grid-cols-1 items-center gap-5 lg:flex 2xl:flex-[60%]">
      <BaseSelect
        v-model="category"
        label="Рубрика"
        :options="categories"
        class="max-lg:w-full lg:w-1/4"
      />

      <BaseSelect
        v-model="period"
        label="Период"
        :options="periodOptions"
        class="max-lg:w-full lg:w-1/4"
      />
    </div>

    <div
      class="ml-auto flex shrink-0 flex-wrap items-center justify-between gap-5 max-md:w-full md:justify-end 2xl:flex-[40%]"
    >
      <BaseSelect
        v-model="sort"
        label="Сортировка"
        :options="sortOptions"
        class="max-lg:w-full 2xl:w-1/3"
      />

      <div
        class="flex min-w-[280px] flex-1 items-center gap-2 max-lg:w-full md:flex-none"
      >
        <div class="relative w-full">
          <span
            class="absolute inset-y-0 left-3 flex items-center text-new-gray-lighter"
          >
            <svg
              class="size-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </span>
          <input
            v-model="search"
            type="text"
            placeholder="Поиск по каталогу"
            class="h-[38px] w-full rounded-lg border border-[#E9E9E9] pl-9 pr-3 text-[14px] outline-none transition-colors focus:border-[#D9D9D9]"
            @keydown.enter="handleSearchSubmit"
          />
        </div>

        <button
          type="button"
          class="h-[38px] rounded-lg bg-specialprojectsection px-5 text-[12px] font-bold uppercase tracking-wider text-white-100 transition-opacity hover:opacity-90"
          @click="handleSearchSubmit"
        >
          Найти
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import api from '~~/services/api/api';

const emit = defineEmits([
  'change-category',
  'change-period',
  'change-sort',
  'submit-search',
]);

const route = useRoute();

const category = ref(route.query.category || '');
const period = ref(route.query.period || '');
const sort = ref(route.query.sort || 'last');
const search = ref(route.query.search || '');

let isSyncingFromRoute = false;

watch(category, (value) => {
  if (isSyncingFromRoute) return;
  emit('change-category', value);
});
watch(period, (value) => {
  if (isSyncingFromRoute) return;
  emit('change-period', value);
});
watch(sort, (value) => {
  if (isSyncingFromRoute) return;
  emit('change-sort', value);
});

const handleSearchSubmit = () => {
  emit('submit-search', search.value);
};

watch(
  () => route.query,
  (query) => {
    isSyncingFromRoute = true;
    category.value = query.category || '';
    period.value = query.period || '';
    sort.value = query.sort || 'last';
    search.value = query.search || '';
    nextTick(() => {
      isSyncingFromRoute = false;
    });
  },
  { deep: true },
);

const { data: rubrics } = useAsyncData('wiki-rubrics', async () => {
  const res = await api.wikis.getWikisRubrics();
  return res?.data ?? null;
});

const { data: periods } = useAsyncData('wiki-periods', async () => {
  const res = await api.wikis.getWikisPeriods();
  return res?.data?.data ?? null;
});

const categories = computed(() => [
  { label: 'Все рубрики', value: '' },
  ...(rubrics.value?.data ?? []).map((item) => ({
    label: item.title,
    value: item.slug,
  })),
]);

const periodOptions = computed(() => [
  { label: 'Все периоды', value: '' },
  ...(periods.value ?? []).map((item) => ({
    label: item.title,
    value: item.slug,
  })),
]);

const sortOptions = [
  { label: 'Новое', value: 'last' },
  { label: 'Популярное', value: 'views' },
  { label: 'Выбор редакции', value: 'select_redaction' },
  // { label: 'Выбор читателей', value: 'select_reader' },
];
</script>
